import directusServer from "./directus/directusGraphQLInstance"
import { rethrowIfDatabaseUnavailable } from "./errors/database"

const getAllPostsByCategory = async ({
  limit,
  page,
  skill_slug = "unknown",
}: { limit?: number; page?: number; skill_slug?: string } = {}) => {
  try {
    const response = await directusServer.query(
      `
			query allBlogPosts($page: Int, $limit: Int, $skill_slug:String ) {
				posts(
					sort:  "-date_created",
					filter: {
						status: { _eq: "published" },
						skills: { skills_id: { slug: { _eq: $skill_slug } } }
					}
					page: $page,
					limit: $limit,
				) {
					id,
					slug,
					date_created,
					title,
					headline,
					featured,
					role,
					evidence_metric,
					date_created
					read_time
					image {
						id
						width
						height
						filename_download
					}
					body
					author {
							name
							surname
							image {
								id
								width
								height
								filename_download
							}
					}
					category {
						category_id {
							id
							title
							color
							slug
							description
							image {
								id
								width
								height
								filename_download
							}
						}
					}
					skills {
						skills_id(
							sort:  "slug",
							filter: { status: { _eq: "published" } }
						) {
							id
							slug
							name
						}
					}
				}
			}
			`,
      {
        limit: limit,
        page: page,
        skill_slug: skill_slug,
      }
    )

    // console.log(response);

    return response
  } catch (error) {
    rethrowIfDatabaseUnavailable(error)
    console.error(error)
    console.error(
      "skill_slug: " + skill_slug,
      "limit: " + limit,
      "page: " + page
    )
    return null
  }
}

export default getAllPostsByCategory
